import { render, staticRenderFns } from "./VimeoPlayer.vue?vue&type=template&id=448ebb96"
import script from "./VimeoPlayer.vue?vue&type=script&lang=js"
export * from "./VimeoPlayer.vue?vue&type=script&lang=js"
import style0 from "./VimeoPlayer.vue?vue&type=style&index=0&id=448ebb96&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports